import { Abacus } from "core/Abacus.Core";
import "jquery/ElementHelpers/ElementHelpers";
import "jquery/Plugins/TableSorter/jquery.tablesorter";
import "core/Abacus.Core.Imports";

$(document).ready(function() {
  // CT-193 Access Messaging return URL
  $("a.ad-append-return").each(function(i, el) {
    this.href =
      this.href +
      (this.href.indexOf("?") >= 0 ? "&" : "?") +
      "returl=" +
    encodeURIComponent(location.href.replace("?adredir=1", "").replace("&adredir=1", ""));
  });

  Abacus.InitUI(document.body);
});

// Basic UI initalisation, for pages and popups
Abacus.InitUI = function(context) {
  var context = $(context);

  context.on("click", ".make-opener", function() {
    $(this).toggleClass("show");
  });

  context.find(".placeholder").each(function() {
    $(this).makePlaceholder();
  });
  context.find(".tabbedblocks").each(function() {
    $(this).makeTabbed(".block", ".block > H2, .block > H3");
  });
  context.find(".make.expandable").each(function() {
    $(this).makeExpandable(6);
  });
  context.find(".make.videoblock").each(function() {
    $(this).makeVideoBlock();
  });
  context.find(".newWindow").each(function() {
    $(this).openInNewWindow();
  });
  context.find(".embed").each(function() {
    $(this).embedContent();
  });
  context.find("table.sortable").each(function() {
    var self = $(this);
    setTimeout(function() {
      self.tablesorter();
    }, 0);
  });

  $(window).trigger("abacus:InitUI", context);
};



// WEBPACK FOOTER //
// ./Javascript/main.js